import { friendlyProgressSummary, friendlyProgressTraceText } from '../appShell/progressLabelVocabulary.js'
import { buildStreamProgressPatch } from './streamProgressPatch.js'

/** @param {import('./runApiCompletionStream.js').ApiCompletionCtx} ctx */
export function applyStreamProgressEvent(ctx, event) {
  if (!event || typeof event !== 'object') return
  const traceText = traceTextFromEvent(event)
  const summary = summaryFromEvent(event)
  if (!traceText && !summary) return

  const eventId = event.eventId || `${event.type}:${event.status || ''}:${event.traceText || ''}`
  ctx.setMessagesByThreadId((inner) => {
    const list = [...(inner[ctx.tid] ?? [])]
    const idx = list.findIndex((m) => m.id === ctx.pendingId)
    if (idx === -1) return inner

    const prev = list[idx]
    const seen = Array.isArray(prev.streamProgressEventIds)
      ? new Set(prev.streamProgressEventIds)
      : new Set()
    if (eventId && seen.has(eventId)) return inner
    if (eventId) seen.add(eventId)

    const next = [...list]
    next[idx] = {
      ...prev,
      ...buildStreamProgressPatch(prev, event, traceText, summary, seen),
    }
    return { ...inner, [ctx.tid]: next }
  })
}

function traceTextFromEvent(event) {
  if (event.type === 'progress_event') return friendlyProgressTraceText(event)
  if (event.type === 'run_started' || event.type === 'run_status') return friendlyProgressTraceText(event)
  return ''
}

function summaryFromEvent(event) {
  if (event.type === 'progress_event' || event.type === 'run_status' || event.type === 'run_started') {
    return friendlyProgressSummary(event)
  }
  return ''
}
